/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7.913 8.747a.904.904 0 0 0-1.275-.065.898.898 0 0 0-.066 1.27l4.796 5.303a.904.904 0 0 0 1.342-.003l4.72-5.255a.898.898 0 0 0-.07-1.271.904.904 0 0 0-1.274.07L12.39 12.91a.48.48 0 0 1-.713 0L7.913 8.748Z"
})), "0 0 24 24", "ChevronDown");